import { Link } from "./link.model"

export class Sponsor {
	id: number
	uuid: string
	name: string
	active: boolean = true
	sponsorSince: string
	inactiveSince: string
	email: string
	phone: string
	contributionDescription: string
	considerationDescription: string
	nrStipulatedTkts: number
	merchantId: string
	_links: {
		self: Link,
	}
}



// WEBPACK FOOTER //
// ./src/app/models/sponsor.model.ts